var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExtensible(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1115",
    "data-name": "Group 1115",
    transform: "translate(-5 510)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1073",
    "data-name": "Group 1073",
    transform: "translate(5 -510)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1072",
    "data-name": "Group 1072",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1071",
    "data-name": "Group 1071"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    fill: "#ff7557",
    d: "M88.894-508.621a14.11,14.11,0,0,1,10.432,4.292,14.112,14.112,0,0,1,4.294,10.435v67.788a14.691,14.691,0,0,1-3.991,10.47c-2.665,2.864-6.177,4.257-10.736,4.257H21.109a14.049,14.049,0,0,1-10.436-4.3,14.047,14.047,0,0,1-4.294-10.432v-67.788a14.076,14.076,0,0,1,4.3-10.434,14.074,14.074,0,0,1,10.433-4.293H88.894m0-1.379H21.109A15.536,15.536,0,0,0,9.7-505.3,15.53,15.53,0,0,0,5-493.894v67.788A15.5,15.5,0,0,0,9.7-414.7,15.5,15.5,0,0,0,21.109-410H88.894q7.378,0,11.746-4.7A16.162,16.162,0,0,0,105-426.106v-67.788a15.573,15.573,0,0,0-4.7-11.409A15.573,15.573,0,0,0,88.894-510Z",
    transform: "translate(-5 510)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1114",
    "data-name": "Group 1114",
    transform: "translate(20.233 -488.276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1074",
    "data-name": "Group 1074",
    transform: "translate(9.281 32.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    fill: "#ff7557",
    d: "M117.577-342.494H78.858a2.77,2.77,0,0,1-2.767-2.767v-8.052h44.25v8.054A2.768,2.768,0,0,1,117.577-342.494Zm-40.106-9.44v6.673a1.389,1.389,0,0,0,1.387,1.387h38.719a1.387,1.387,0,0,0,1.385-1.385v-6.675Z",
    transform: "translate(-76.091 353.313)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1075",
    "data-name": "Group 1075",
    transform: "translate(9.281 13.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    fill: "#ff7557",
    d: "M120.341-397.243H76.091v-8.052a2.771,2.771,0,0,1,2.767-2.767h38.656a2.83,2.83,0,0,1,2.827,2.827ZM77.47-398.622h41.491v-6.613a1.449,1.449,0,0,0-1.447-1.447H78.858a1.389,1.389,0,0,0-1.388,1.388Z",
    transform: "translate(-76.091 408.062)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1076",
    "data-name": "Group 1076",
    transform: "translate(60.018 27.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    fill: "#ff7557",
    d: "M230.014-365.621h-6.1a.69.69,0,0,1-.69-.69.69.69,0,0,1,.69-.69h6.1a.69.69,0,0,1,.69.69A.69.69,0,0,1,230.014-365.621Z",
    transform: "translate(-223.228 367)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1077",
    "data-name": "Group 1077",
    transform: "translate(26.587 18.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    fill: "#ff7557",
    d: "M159.808-393H126.967a.69.69,0,0,1-.69-.69.69.69,0,0,1,.69-.69h32.841a.69.69,0,0,1,.69.69A.689.689,0,0,1,159.808-393Z",
    transform: "translate(-126.277 394.375)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1078",
    "data-name": "Group 1078",
    transform: "translate(26.587 27.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    fill: "#ff7557",
    d: "M152.335-365.621H126.967a.69.69,0,0,1-.69-.69.69.69,0,0,1,.69-.69h25.369a.69.69,0,0,1,.69.69A.69.69,0,0,1,152.335-365.621Z",
    transform: "translate(-126.277 367)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1079",
    "data-name": "Group 1079",
    transform: "translate(26.587 37.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    fill: "#ff7557",
    d: "M159.808-338.246H126.967a.69.69,0,0,1-.69-.69.69.69,0,0,1,.69-.69h32.841a.689.689,0,0,1,.69.69A.69.69,0,0,1,159.808-338.246Z",
    transform: "translate(-126.277 339.625)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1080",
    "data-name": "Group 1080",
    transform: "translate(59.625 18.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    fill: "#ff7557",
    d: "M222.778-374.116a.69.69,0,0,1-.69-.69v-18.879a.69.69,0,0,1,.69-.69.69.69,0,0,1,.69.69v18.879A.69.69,0,0,1,222.778-374.116Z",
    transform: "translate(-222.088 394.375)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1090",
    "data-name": "Group 1090",
    transform: "translate(14.101 17.853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1081",
    "data-name": "Group 1081"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95",
    "data-name": "Ellipse 95",
    fill: "#ff7557",
    cx: 0.983,
    cy: 0.983,
    r: 0.983
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1082",
    "data-name": "Group 1082",
    transform: "translate(6.293)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96",
    "data-name": "Ellipse 96",
    fill: "#ff7557",
    cx: 0.983,
    cy: 0.983,
    r: 0.983
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1083",
    "data-name": "Group 1083",
    transform: "translate(3.146)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_97",
    "data-name": "Ellipse 97",
    fill: "#ff7557",
    cx: 0.983,
    cy: 0.983,
    r: 0.983
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1084",
    "data-name": "Group 1084",
    transform: "translate(0 9.439)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_98",
    "data-name": "Ellipse 98",
    fill: "#ff7557",
    cx: 0.983,
    cy: 0.983,
    r: 0.983
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1085",
    "data-name": "Group 1085",
    transform: "translate(6.293 9.439)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    fill: "#ff7557",
    cx: 0.983,
    cy: 0.983,
    r: 0.983
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1086",
    "data-name": "Group 1086",
    transform: "translate(3.146 9.439)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    fill: "#ff7557",
    cx: 0.983,
    cy: 0.983,
    r: 0.983
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1087",
    "data-name": "Group 1087",
    transform: "translate(0 18.879)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    "data-name": "Ellipse 101",
    fill: "#ff7557",
    cx: 0.983,
    cy: 0.983,
    r: 0.983
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1088",
    "data-name": "Group 1088",
    transform: "translate(6.293 18.879)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_102",
    "data-name": "Ellipse 102",
    fill: "#ff7557",
    cx: 0.983,
    cy: 0.983,
    r: 0.983
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1089",
    "data-name": "Group 1089",
    transform: "translate(3.146 18.879)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_103",
    "data-name": "Ellipse 103",
    fill: "#ff7557",
    cx: 0.983,
    cy: 0.983,
    r: 0.983
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1091",
    "data-name": "Group 1091",
    transform: "translate(9.281 22.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    fill: "#ff7557",
    d: "M76.781-369.853a.689.689,0,0,1-.69-.69v-9.4a.689.689,0,0,1,.69-.69.689.689,0,0,1,.69.69v9.4A.689.689,0,0,1,76.781-369.853Z",
    transform: "translate(-76.091 380.636)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1092",
    "data-name": "Group 1092",
    transform: "translate(52.15 22.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    fill: "#ff7557",
    d: "M201.1-369.853a.689.689,0,0,1-.69-.69v-9.4a.689.689,0,0,1,.69-.69.689.689,0,0,1,.69.69v9.4A.689.689,0,0,1,201.1-369.853Z",
    transform: "translate(-200.409 380.636)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1093",
    "data-name": "Group 1093",
    transform: "translate(14.454 8.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    fill: "#ff7557",
    d: "M91.781-416.969a.69.69,0,0,1-.69-.69v-5.016a.69.69,0,0,1,.69-.69.69.69,0,0,1,.69.69v5.016A.69.69,0,0,1,91.781-416.969Z",
    transform: "translate(-91.091 423.364)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1094",
    "data-name": "Group 1094",
    transform: "translate(9.751 3.448)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    fill: "#ff7557",
    d: "M82.689-431.075a.689.689,0,0,1-.488-.2l-4.546-4.546a.69.69,0,0,1,0-.975.69.69,0,0,1,.976,0l4.546,4.546a.69.69,0,0,1,0,.975A.689.689,0,0,1,82.689-431.075Z",
    transform: "translate(-77.454 437)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1095",
    "data-name": "Group 1095",
    transform: "translate(4.736 3.448)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    fill: "#ff7557",
    d: "M68.615-435.621H63.6a.69.69,0,0,1-.69-.69.69.69,0,0,1,.69-.69h5.016a.69.69,0,0,1,.69.69A.69.69,0,0,1,68.615-435.621Z",
    transform: "translate(-62.909 437)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1096",
    "data-name": "Group 1096",
    transform: "translate(11.632 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    fill: "#ff7557",
    d: "M88.144-441.075a.688.688,0,0,1-.488-.2l-4.546-4.546a.689.689,0,0,1,0-.975.689.689,0,0,1,.975,0l4.546,4.546a.689.689,0,0,1,0,.975A.688.688,0,0,1,88.144-441.075Z",
    transform: "translate(-82.909 447)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1097",
    "data-name": "Group 1097",
    transform: "translate(6.617 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    fill: "#ff7557",
    d: "M74.069-445.621H69.054a.69.69,0,0,1-.69-.69.69.69,0,0,1,.69-.69h5.016a.69.69,0,0,1,.69.69A.69.69,0,0,1,74.069-445.621Z",
    transform: "translate(-68.364 447)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1098",
    "data-name": "Group 1098",
    transform: "translate(17.589 8.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    fill: "#ff7557",
    d: "M100.872-416.969a.69.69,0,0,1-.69-.69v-5.016a.69.69,0,0,1,.69-.69.69.69,0,0,1,.69.69v5.016A.69.69,0,0,1,100.872-416.969Z",
    transform: "translate(-100.182 423.364)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1099",
    "data-name": "Group 1099",
    transform: "translate(17.589 8.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    fill: "#ff7557",
    d: "M114.038-421.985H100.872a.689.689,0,0,1-.69-.69.69.69,0,0,1,.69-.69h13.166a.69.69,0,0,1,.69.69A.69.69,0,0,1,114.038-421.985Z",
    transform: "translate(-100.182 423.364)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1100",
    "data-name": "Group 1100",
    transform: "translate(16.334 4.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    fill: "#ff7557",
    d: "M120.746-431.985H97.235a.69.69,0,0,1-.69-.69.69.69,0,0,1,.69-.69h23.511a.69.69,0,0,1,.69.69A.689.689,0,0,1,120.746-431.985Z",
    transform: "translate(-96.545 433.364)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1101",
    "data-name": "Group 1101",
    transform: "translate(14.454 42.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    fill: "#ff7557",
    d: "M91.781-318.787a.69.69,0,0,1-.69-.69v-5.016a.69.69,0,0,1,.69-.69.69.69,0,0,1,.69.69v5.016A.69.69,0,0,1,91.781-318.787Z",
    transform: "translate(-91.091 325.182)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1102",
    "data-name": "Group 1102",
    transform: "translate(9.751 47.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    fill: "#ff7557",
    d: "M78.144-304.257a.688.688,0,0,1-.488-.2.69.69,0,0,1,0-.975l4.546-4.546a.691.691,0,0,1,.976,0,.69.69,0,0,1,0,.975l-4.546,4.546A.687.687,0,0,1,78.144-304.257Z",
    transform: "translate(-77.454 310.181)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1103",
    "data-name": "Group 1103",
    transform: "translate(4.736 51.724)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    fill: "#ff7557",
    d: "M68.615-295.621H63.6a.69.69,0,0,1-.69-.69.69.69,0,0,1,.69-.69h5.016a.69.69,0,0,1,.69.69A.69.69,0,0,1,68.615-295.621Z",
    transform: "translate(-62.909 297)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1104",
    "data-name": "Group 1104",
    transform: "translate(11.632 50.627)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    fill: "#ff7557",
    d: "M83.6-294.257a.686.686,0,0,1-.488-.2.689.689,0,0,1,0-.975l4.546-4.546a.69.69,0,0,1,.975,0,.689.689,0,0,1,0,.975l-4.546,4.546A.686.686,0,0,1,83.6-294.257Z",
    transform: "translate(-82.909 300.181)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1105",
    "data-name": "Group 1105",
    transform: "translate(6.617 55.172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    fill: "#ff7557",
    d: "M74.069-285.621H69.054a.69.69,0,0,1-.69-.69.69.69,0,0,1,.69-.69h5.016a.69.69,0,0,1,.69.69A.69.69,0,0,1,74.069-285.621Z",
    transform: "translate(-68.364 287)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1106",
    "data-name": "Group 1106",
    transform: "translate(17.589 42.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    fill: "#ff7557",
    d: "M100.872-318.787a.69.69,0,0,1-.69-.69v-5.016a.69.69,0,0,1,.69-.69.69.69,0,0,1,.69.69v5.016A.69.69,0,0,1,100.872-318.787Z",
    transform: "translate(-100.182 325.182)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1107",
    "data-name": "Group 1107",
    transform: "translate(17.589 47.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    fill: "#ff7557",
    d: "M114.038-309.257H100.872a.69.69,0,0,1-.69-.69.689.689,0,0,1,.69-.69h13.166a.69.69,0,0,1,.69.69A.69.69,0,0,1,114.038-309.257Z",
    transform: "translate(-100.182 310.636)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1108",
    "data-name": "Group 1108",
    transform: "translate(16.334 50.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    fill: "#ff7557",
    d: "M120.746-299.257H97.235a.69.69,0,0,1-.69-.69.69.69,0,0,1,.69-.69h23.511a.689.689,0,0,1,.69.69A.69.69,0,0,1,120.746-299.257Z",
    transform: "translate(-96.545 300.636)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1109",
    "data-name": "Group 1109",
    transform: "translate(0 49.543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    fill: "#ff7557",
    d: "M52.238-297.2a3.067,3.067,0,0,1-3.063-3.063,3.067,3.067,0,0,1,3.063-3.063,3.067,3.067,0,0,1,3.063,3.063A3.067,3.067,0,0,1,52.238-297.2Zm0-4.747a1.686,1.686,0,0,0-1.684,1.684,1.686,1.686,0,0,0,1.684,1.684,1.686,1.686,0,0,0,1.684-1.684A1.686,1.686,0,0,0,52.238-301.947Z",
    transform: "translate(-49.175 303.326)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1110",
    "data-name": "Group 1110",
    transform: "translate(0 1.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    fill: "#ff7557",
    d: "M52.238-437.454a3.067,3.067,0,0,1-3.063-3.063,3.067,3.067,0,0,1,3.063-3.063,3.067,3.067,0,0,1,3.063,3.063A3.067,3.067,0,0,1,52.238-437.454Zm0-4.748a1.686,1.686,0,0,0-1.684,1.684,1.686,1.686,0,0,0,1.684,1.684,1.686,1.686,0,0,0,1.684-1.684A1.686,1.686,0,0,0,52.238-442.2Z",
    transform: "translate(-49.175 443.581)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1111",
    "data-name": "Group 1111",
    transform: "translate(40.056 48.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    fill: "#ff7557",
    d: "M168.4-301.5a3.067,3.067,0,0,1-3.063-3.063,3.067,3.067,0,0,1,3.063-3.063,3.067,3.067,0,0,1,3.063,3.063A3.067,3.067,0,0,1,168.4-301.5Zm0-4.747a1.686,1.686,0,0,0-1.684,1.684,1.686,1.686,0,0,0,1.684,1.684,1.686,1.686,0,0,0,1.684-1.684A1.686,1.686,0,0,0,168.4-306.249Z",
    transform: "translate(-165.337 307.628)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1112",
    "data-name": "Group 1112",
    transform: "translate(40.056 2.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    fill: "#ff7557",
    d: "M168.4-434.012a3.067,3.067,0,0,1-3.063-3.063,3.067,3.067,0,0,1,3.063-3.063,3.067,3.067,0,0,1,3.063,3.063A3.067,3.067,0,0,1,168.4-434.012Zm0-4.747a1.686,1.686,0,0,0-1.684,1.684,1.686,1.686,0,0,0,1.684,1.684,1.685,1.685,0,0,0,1.684-1.684A1.686,1.686,0,0,0,168.4-438.76Z",
    transform: "translate(-165.337 440.139)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1113",
    "data-name": "Group 1113",
    transform: "translate(66.166 25.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    fill: "#ff7557",
    d: "M244.12-367.757a3.067,3.067,0,0,1-3.063-3.063,3.067,3.067,0,0,1,3.063-3.063,3.067,3.067,0,0,1,3.063,3.063A3.067,3.067,0,0,1,244.12-367.757Zm0-4.748a1.686,1.686,0,0,0-1.684,1.684,1.686,1.686,0,0,0,1.684,1.684,1.686,1.686,0,0,0,1.684-1.684A1.686,1.686,0,0,0,244.12-372.5Z",
    transform: "translate(-241.057 373.884)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtensible);
export default __webpack_public_path__ + "static/media/Extensible.61423ffc9a248617567d1e3d3c34edfd.svg";
export { ForwardRef as ReactComponent };